export const OWNER_BG = '#0B0D12'
export const OWNER_PANEL = '#121520'
export const OWNER_BORDER = 'rgba(255,255,255,0.08)'
export const OWNER_ACCENT = '#5B8CFF'
export const OWNER_STATUS = {
  ok: '#34D399',
  warn: '#FBBF24',
  bad: '#F87171',
}
export const SPARKLINE_COLORS = [OWNER_ACCENT, 'rgba(91,140,255,0.45)']
